import { object, bool } from "prop-types"
import { uniqBy } from "lodash"
import Attendee from "./Attendee"

const Attendees = ({ eventTime, registration, forWaitlist = false }) => {
  const {
    event: { registerForSeparateTimes },
    canceledOn,
    attendees,
    attendeeTypes,
  } = registration

  const registrationAttendeeTypes = attendeeTypes
    .filter((attendeeType) => {
      const eventId = registerForSeparateTimes ? eventTime.id : null
      return attendeeType.signupTimeId === eventId
    })
    .map((attendeeType) => ({
      ...attendeeType,
      attendees: attendees.filter(
        (attendee) =>
          attendee.attendeeType.id === attendeeType.id &&
          attendee.waitlist === forWaitlist,
      ),
    }))
    .filter((attendeeType) => attendeeType.attendees.length > 0)

  const uniqueAttendeeTypes = uniqBy(registrationAttendeeTypes, "id")

  return (
    <div className="mb-3">
      {uniqueAttendeeTypes.length > 0 && registerForSeparateTimes && (
        <div className="fw-500 mb-1">
          {eventTime.date} {eventTime.time}
        </div>
      )}

      {uniqueAttendeeTypes.map((attendeeType) => (
        <Attendee
          key={attendeeType.id}
          attendeeType={attendeeType}
          isCanceled={!!canceledOn}
        />
      ))}
    </div>
  )
}

Attendees.propTypes = {
  eventTime: object,
  registration: object,
  forWaitlist: bool,
}

export default Attendees
